import React, { Fragment } from 'react'
import { metaWebDevelopment } from '../../../../Utilites'
import MetaTagComponent from '../../../common/Meta/MetaTagComponent'
import ServiceDetailSection from '../../../services/ServiceDetailSection'
import { Cloud, Code, Database, FileJson, Globe, Hexagon, Package, Rocket, Search, Shield, Smartphone, TrendingUp, Zap } from 'lucide-react'

const WebDevelopment = () => {
  const service = {
    slug: 'web-development',
    title: 'Web Development',
    description: 'Custom web applications built with modern technologies for optimal performance and user experience.',
    shortDescription: 'Custom websites built with modern technologies and best practices.',
    icon: Code,
    gradient: 'from-blue-500 to-cyan-500',
    features: [
      'Responsive Web Design',
      'Progressive Web Apps',
      'Custom CMS Development',
      'API Integration',
      'Performance Optimization',
      'Security Implementation'
    ],
    benefits: [
      'Fast Loading Speeds',
      'Mobile-First Design',
      'Scalable Architecture',
      'SEO-Friendly Structure'
    ],
    process: [
      'Requirements Analysis',
      'UI/UX Design',
      'Development & Testing',
      'Deployment & Launch',
      'Ongoing Maintenance'
    ],
    image: 'https://images.unsplash.com/photo-1547658719-da2b51169166?w=800&h=600&fit=crop'
  }

  const extension = {
    keyFeatures: [
      { name: 'Responsive Design', description: 'Mobile-first, cross-device compatibility', icon: Smartphone },
      { name: 'Performance Optimization', description: 'Fast loading times and optimized user experience', icon: Zap },
      { name: 'SEO-Friendly Structure', description: 'Built for search engine optimization', icon: TrendingUp },
      { name: 'Security Implementation', description: 'Advanced security measures and best practices', icon: Shield },
      { name: 'Custom CMS Development', description: 'Tailored content management solutions', icon: Database },
      { name: 'API Integration', description: 'Seamless third-party service integration', icon: Globe }
    ],
    benefits: [
      { title: 'Lightning Fast Performance', description: 'Optimized for speed and user experience', icon: Zap },
      { title: 'Mobile-First Design', description: 'Perfect experience on all devices', icon: Smartphone },
      { title: 'Scalable Architecture', description: 'Built to grow with your business', icon: Rocket },
      { title: 'SEO Optimized', description: 'Designed for search engine visibility', icon: Search }
    ],
    process: [
      { step: 'Requirements Analysis', description: 'Understand your business needs and goals', duration: '1 week' },
      { step: 'UI/UX Design', description: 'Create intuitive and engaging designs', duration: '2-3 weeks' },
      { step: 'Development & Testing', description: 'Build and thoroughly test your application', duration: '4-8 weeks' },
      { step: 'Deployment & Launch', description: 'Deploy to production and launch', duration: '1 week' },
      { step: 'Ongoing Maintenance', description: 'Continuous support and updates', duration: 'Ongoing' }
    ],
    techStack: [
      { name: 'React', icon: Code, category: 'Frontend' },
      { name: 'Node.js', icon: Hexagon, category: 'Backend' },
      { name: 'Next JS', icon: Code, category: 'Frontend' },
      { name: 'TypeScript', icon: FileJson, category: 'Language' },
      { name: 'Laravel', icon: FileJson, category: 'Language' },
      { name: 'PostgreSQL', icon: Database, category: 'Database' },
      { name: 'AWS', icon: Cloud, category: 'Cloud' },
      { name: 'MySQL', icon: Database, category: 'Database' },
      { name: 'Docker', icon: Package, category: 'DevOps' }
    ]
  }
  return (
    <Fragment>
        <MetaTagComponent metaDetails={metaWebDevelopment}/>
        <ServiceDetailSection service={service}  extension={extension}/>
    </Fragment>
  )
}

export default WebDevelopment